import React ,{ Fragment } from "react";
import { List } from "antd-mobile";
import { observer } from "mobx-react";
import FoodStepper from "./FoodStepper";
import _ from "underscore";
import AddonUI from "./AddonUI";

const Item = List.Item;
const regexDefaultImage = /https:\/\/www\.foodzaps\.com\/public\/img\/dish\d+\.png/g;

const AddonFixed = observer(({ addon, price_zero, isCustomize, screen, cartStore }) => {
	let nameAd = addon.name;
	if(isCustomize) {
		if(screen==='cart') {
			nameAd=addon.name +' ('+addon.priceName+')';
		} else if(screen==='iteminfo') {
			nameAd=addon.priceName;
		}
	}

	if(addon.image && (addon.image).match(regexDefaultImage)) {
		addon.image = false;
	}
	
	// Check for membership price if item has priceOptions
	let standardPrice = parseFloat(addon.price) || 0;
	let membershipPrice = standardPrice; // Default to standard price
	let hasMembershipDiscount = false;
	let priceDifference = 0;
	let showMembershipDiscount = false;
	
	// Check if we can access item with price options
	if (addon.item && addon.item.priceOptions) {
		const priceOptions = addon.item.priceOptions;
		const standardOption = priceOptions.find(opt => 
			opt && opt.name && String(opt.name).toLowerCase() === 'standard'
		);
		const membershipOption = priceOptions.find(opt => 
			opt && opt.name && String(opt.name).toLowerCase() === 'membership'
		);
		
		if (standardOption && membershipOption) {
			standardPrice = parseFloat(standardOption.price) || 0;
			membershipPrice = parseFloat(membershipOption.price) || 0;
			hasMembershipDiscount = standardPrice > membershipPrice;
			priceDifference = (standardPrice - membershipPrice).toFixed(2);
			
			// Check if logged in and social provider is appropriate
			const isLoggedIn = cartStore && cartStore.menuStore && 
				cartStore.menuStore.isLoginModalVisible === false && 
				cartStore.menuStore.social && 
				Object.keys(cartStore.menuStore.social).length !== 0;
			const isMembershipProvider = cartStore && cartStore.menuStore && 
				cartStore.menuStore.socialProvider === 'advocado';
			
			showMembershipDiscount = isLoggedIn && hasMembershipDiscount && isMembershipProvider;
		}
	}
	
	return (
		<AddonUI
			uiType="fixed"
			enableImage={cartStore && cartStore.menuStore && addon.image ? cartStore.menuStore.isSubItemImageEnable() : false}
			thumb={addon.image}
			title={nameAd}
			price={
				showMembershipDiscount ? (
					<div className="price-display">
						<span className="standard-price">
							{cartStore.menuStore.currencySymbol}{membershipPrice.toFixed(2)}
						</span>
						<div className="price-difference-amount">
							-{cartStore.menuStore.currencySymbol}{priceDifference}
						</div>
					</div>
				) : (
					parseFloat(addon.price) === 0 ? price_zero : `(${addon.priceName})`
				)
			}
			quantity={addon.quantity}
		></AddonUI>
	);
});

const AddonSingle = observer(({ addon, handler, price_zero,isCustomize,screen,getSetMealErrorHandler ,cartStore}) => {
	// console.log('AddonSingle',addon);
	let nameAd=addon.name;
	if(isCustomize)
	{
		if(screen==='cart')
		{
			nameAd=addon.name +' ('+addon.priceName+')';
		}
		else if(screen==='iteminfo')
		{
			nameAd=addon.priceName;
		}
	}
	
	// Use combinedPricing data from parent component preprocessing
	let hasDuplicateWithDifferentPrice = false;
	let standardPrice = parseFloat(addon.price) || 0;
	let membershipPrice = standardPrice;

	if (addon.combinedPricing && addon.combinedPricing.hasDifferentPrices) {
		hasDuplicateWithDifferentPrice = true;
		standardPrice = addon.combinedPricing.standardPrice;
		membershipPrice = addon.combinedPricing.membershipPrice;
		// shouldHideThisAddon is already handled by parent - we only get visible addons
	}

	// Debug: Show final pricing logic
	if (hasDuplicateWithDifferentPrice) {
		//console.log('[Addon] ✅', addon.name, '- Standard: $' + standardPrice + ', Member: $' + membershipPrice);
	}

	// Note: Duplicate hiding is now handled by parent component preprocessing

	// Check if user is logged in and has membership
	const isLoggedIn = cartStore && cartStore.menuStore && 
		cartStore.menuStore.isLoginModalVisible === false && 
		cartStore.menuStore.social && 
		Object.keys(cartStore.menuStore.social).length > 0;

	const tokenExpiry = localStorage.getItem(
		`${cartStore && cartStore.menuStore && cartStore.menuStore.controller ? cartStore.menuStore.controller : ''}_advocado_token_expiry`
	);
	const now = new Date().getTime();
	const useMembership = tokenExpiry && parseInt(tokenExpiry) > now;

	const shouldShowMembershipPricing = isLoggedIn && useMembership && 
		cartStore && cartStore.menuStore && cartStore.menuStore.social && cartStore.menuStore.social.provider === 'advocado';

	let inputTag= <input
		name={addon.id}
		type="checkbox"
		checked={addon.quantity === 1 ? true : false}
		onChange={() => {}}
		disabled={addon.isInStock ? "" : "disabled"}
	/>;

	if(cartStore && cartStore.menuStore.layout===4)
	{
		// Create pricing display
		let priceDisplay = null;
		if (hasDuplicateWithDifferentPrice) {
			if (shouldShowMembershipPricing) {
				// User is logged in with membership - show member price as primary
				priceDisplay = (
					<div style={{marginTop: '6px', lineHeight: '1.5'}}>
						<div className="itemPrice standard-price">Standard: {cartStore.menuStore.currencySymbol} {standardPrice.toFixed(2)}</div>
						<div className="itemPrice membership-price" style={{color: 'rgb(255, 107, 0)', marginTop: '2px'}}>Member: {cartStore.menuStore.currencySymbol} {membershipPrice.toFixed(2)}</div>
					</div>
				);
			} else {
				// User not logged in - show standard price with membership preview
				priceDisplay = (
					<div style={{marginTop: '6px', lineHeight: '1.5'}}>
						<div className="itemPrice standard-price">Standard: {cartStore.menuStore.currencySymbol} {standardPrice.toFixed(2)}</div>
						<div className="itemPrice membership-price" style={{color: 'rgb(255, 107, 0)', marginTop: '2px'}}>Member: {cartStore.menuStore.currencySymbol} {membershipPrice.toFixed(2)}</div>
					</div>
				);
			}
		} else if (standardPrice > 0) {
			priceDisplay = <span className="addonPrice"> +{cartStore.menuStore.currencySymbol} {standardPrice.toFixed(2)}</span>;
		}

		nameAd = (
			<Fragment>
				<span className="addsName">{addon.name}</span>
				{priceDisplay}
			</Fragment>
		);

		inputTag=<div class="themeCheckbox">
		<input
			name={addon.id}
			type="checkbox"
			checked={addon.quantity === 1 ? true : false}
			onChange={() => {}}
			disabled={addon.isInStock ? "" : "disabled"}
        />
			<span class="dotter">&nbsp;</span>
		</div>;
	}

	if(addon.image && (addon.image).match(regexDefaultImage))
	{
		addon.image = false;
	}

	// Create price display for non-layout-4
	let priceElement = null;
	if (!cartStore || cartStore.menuStore.layout !== 4) {
		if (hasDuplicateWithDifferentPrice) {

			if (shouldShowMembershipPricing) {
				// User is logged in with membership - show member price as primary
				priceElement = (
					<div className="addon-price-container" style={{marginTop: '6px', lineHeight: '1.5'}}>
						<div className="itemPrice standard-price">Standard: {cartStore.menuStore.currencySymbol} {standardPrice.toFixed(2)}</div>
						<div className="itemPrice membership-price" style={{color: 'rgb(255, 107, 0)', marginTop: '2px'}}>Member: {cartStore.menuStore.currencySymbol} {membershipPrice.toFixed(2)}</div>
					</div>
				);
			} else {
				// User not logged in - show standard price with membership preview
				priceElement = (
					<div className="addon-price-container" style={{marginTop: '6px', lineHeight: '1.5'}}>
						<div className="itemPrice standard-price">Standard: {cartStore.menuStore.currencySymbol} {standardPrice.toFixed(2)}</div>
						<div className="itemPrice membership-price" style={{color: 'rgb(255, 107, 0)', marginTop: '2px'}}>Member: {cartStore.menuStore.currencySymbol} {membershipPrice.toFixed(2)}</div>
					</div>
				);
			}
		} else {
			priceElement = (
				<span className="gray">
					{parseFloat(addon.price) === 0 ? price_zero : `(${addon.priceName})`}
				</span>
			);
		}
	}

	return (
		<React.Fragment>
			{/* <Item
				className="itemAddon addoncheckbox"
				extra={inputTag}
				onClick={() => {
					let qty=addon.quantity === 0 ? 1 : 0;
					if (addon.isInStock) handler(qty);
					if(qty>0)
					{	
						//getSetMealErrorHandler('minus1');		
						let validateSetMeals=getSetMealErrorHandler('checked');
						if (validateSetMeals!=="")
						{
							handler(0);
						}
					}
					else{
						getSetMealErrorHandler('minus');
					}					
				}}
			>
				<div className="addonNames" >{nameAd}</div>
				{(!cartStore || cartStore.menuStore.layout!==4) && (
					<span className="gray">
						{parseFloat(addon.price) === 0 ? price_zero : `(${addon.priceName})`}
					</span>
				)}
			</Item> */}

			<AddonUI
				uiType="radio"
				name={`${addon.groupName}-${addon.addonListIndex || 0}`}
				addonId={addon.id}
				min={addon.min}
				enableImage={cartStore && cartStore.menuStore && addon.image ? cartStore.menuStore.isSubItemImageEnable() : false}
				thumb={addon.image}
				title={nameAd} 
				price={priceElement}
				quantity={addon.quantity}
				onCheck={() => {
					// console.log('AddonSingle onCheck called, addon:', addon.name, 'current quantity:', addon.quantity);
					// For optional addons, allow unchecking by clicking again
					// For required addons, always keep selected
					let qty;
					if (addon.min > 0) {
						// Required addon - always set to 1
						qty = 1;
					} else {
						// Optional addon - toggle between 0 and 1
						qty = addon.quantity === 0 ? 1 : 0;
					}
					// console.log('Setting quantity to:', qty, '(min:', addon.min, ')');
					if (addon.isInStock) {
						handler(qty);
					}
				}}
			>
			</AddonUI>
		</React.Fragment>
	);
});

const ModifierSingle = observer(({handler,opt,isChecked,cartStore}) => {
	// console.log('AddonMultiple',opt, handler,isChecked);
	let nameAd = <Fragment><span className="addsName">{opt}</span></Fragment>;
	let inputTag=<div class="themeCheckbox">
	<input
		name={"modifier"}
		type="checkbox"
		checked={isChecked}
		onChange={() => {
			//// console.log(2,opt,e);
		}}         
	/>
		<span class="dotter">&nbsp;</span>
	</div>;

	return (
		<React.Fragment>
			{/* <Item
				className="itemAddon addoncheckbox"
				extra={inputTag}
				onClick={() => {
					//// console.log(opt,isChecked);
					handler(opt,isChecked);
				}}
			>
				<div className="addonNames" >{nameAd}</div>		
			</Item> */}
			
			<AddonUI
				uiType="checkbox"
				title={nameAd} 
				enableImage={cartStore && cartStore.menuStore ? cartStore.menuStore.isSubItemImageEnable() : false}
				thumb={false}
				price={``}
				quantity={``}
				isChecked={isChecked}
				onCheck={() => {
					handler(opt,isChecked);
				}}
			>
			</AddonUI>
		</React.Fragment>
	);
});

const AddonMultiple = observer(({ addon, handler, price_zero,isCustomize,screen,getSetMealErrorHandler,cartStore}) => {
	// console.log('AddonMultiple',addon);
	let nameAd=addon.name;
	let nameAd1=addon.name;
	if(isCustomize)
	{
		if(screen==='cart')
		{
			nameAd=addon.name +' ('+addon.priceName+')';
		}
		else if(screen==='iteminfo')
		{
			nameAd=addon.priceName;
		}
	}

	// Check if user is logged in and has membership
	const isLoggedIn = cartStore && cartStore.menuStore && 
		cartStore.menuStore.isLoginModalVisible === false && 
		cartStore.menuStore.social && 
		Object.keys(cartStore.menuStore.social).length > 0;

	const tokenExpiry = localStorage.getItem(
		`${cartStore && cartStore.menuStore && cartStore.menuStore.controller ? cartStore.menuStore.controller : ''}_advocado_token_expiry`
	);
	const now = new Date().getTime();
	const useMembership = tokenExpiry && parseInt(tokenExpiry) > now;

	const shouldShowMembershipPricing = isLoggedIn && useMembership && 
		cartStore && cartStore.menuStore && cartStore.menuStore.social && cartStore.menuStore.social.provider === 'advocado';

	if(cartStore && cartStore.menuStore.layout===4)
	{
		// For layout 4, show membership pricing logic
		let standardPrice = parseFloat(addon.price) || 0;
		let membershipPrice = standardPrice;
		let hasMembershipDiscount = false;

		// Check if addon has membership pricing from parent item's priceOptions
		if (addon.parentItem && addon.parentItem.priceOptions) {
			const membershipOption = addon.parentItem.priceOptions.find(opt => 
				opt && opt.name && String(opt.name).toLowerCase() === 'membership'
			);

			if (membershipOption && membershipOption.set) {
				// Find this specific addon in membership pricing structure
				const memberAddon = membershipOption.set.find(ma => ma.id === addon.id);
				if (memberAddon) {
					membershipPrice = parseFloat(memberAddon.price) || standardPrice;
					hasMembershipDiscount = standardPrice > membershipPrice;
				}
			}
		}

		// Create pricing display
		let priceDisplay = null;
		if (shouldShowMembershipPricing && hasMembershipDiscount) {
			const priceDifference = (standardPrice - membershipPrice).toFixed(2);
			priceDisplay = (
				<Fragment>
					<span className="addonPrice member-price"> +{cartStore.menuStore.currencySymbol} {membershipPrice.toFixed(2)}</span>
					<span className="addon-savings"> (-{cartStore.menuStore.currencySymbol}{priceDifference})</span>
				</Fragment>
			);
		} else if (standardPrice > 0) {
			priceDisplay = <span className="addonPrice"> +{cartStore.menuStore.currencySymbol} {standardPrice.toFixed(2)}</span>;
		}

		nameAd = (
			<Fragment>
				<span className="addsName">{addon.name}</span>
				{priceDisplay}
			</Fragment>
		);
	}

	if(addon.image && (addon.image).match(regexDefaultImage))
	{
		addon.image = false;
	}

	// Create price display for non-layout-4
	let priceElement = addon.priceName;
	if (!cartStore || cartStore.menuStore.layout !== 4) {
		if (shouldShowMembershipPricing && addon.parentItem && addon.parentItem.priceOptions) {
			// Check for membership pricing
			const membershipOption = addon.parentItem.priceOptions.find(opt => 
				opt && opt.name && String(opt.name).toLowerCase() === 'membership'
			);

			if (membershipOption && membershipOption.set) {
				const memberAddon = membershipOption.set.find(ma => ma.id === addon.id);
				if (memberAddon) {
					const standardPrice = parseFloat(addon.price) || 0;
					const memberPrice = parseFloat(memberAddon.price) || standardPrice;

					if (standardPrice > memberPrice) {
						const priceDifference = (standardPrice - memberPrice).toFixed(2);
						priceElement = (
							<div className="addon-price-container">
								<span className="addon-member-price">
									+{cartStore.menuStore.currencySymbol}{memberPrice.toFixed(2)}
								</span>
								<span className="addon-price-difference">
									(-{cartStore.menuStore.currencySymbol}{priceDifference})
								</span>
							</div>
						);
					} else {
						priceElement = `(+${cartStore.menuStore.currencySymbol}${standardPrice.toFixed(2)})`;
					}
				}
			}
		}
	}
	return (
		<React.Fragment>
			{/* <Item
				className="itemAddon"
				extra={
					<FoodStepper
						style={{
							width: "100%",
							minWidth: "100px",
							maxWidth: "150px"
						}}
						flexWidth={true}
						showNumber
						size="small"
						// min={addon.min}
						max={addon.max === 0 ? 99 : addon.max}
						value={addon.quantity}
						onChange={quantity => {
							handler(quantity);
						}}
						disabled={addon.isInStock ? "" : "disabled"}
						_getSetMealErrorMsg={getSetMealErrorHandler}
					/>
				}
			>
				<div className="addonNames" >{nameAd}</div>
				{(!cartStore || cartStore.menuStore.layout!==4) && (<span className="gray">
				{parseFloat(addon.price) === 0 ? price_zero : `(${addon.priceName})`}
				</span>)}
			</Item> */}

			<AddonUI 
				uiType="stepper"
				enableImage={cartStore && cartStore.menuStore && addon.image ? cartStore.menuStore.isSubItemImageEnable() : false}
				thumb={addon.image}
				title={nameAd1} 
				max={addon.max === 0 ? 99 : addon.max}
				disabled={addon.isInStock ? "" : "disabled"}
				onChange={quantity => {
					// console.log('quantity',quantity);
					handler(quantity);
				}}
				onErrorMsg={getSetMealErrorHandler}
				price={priceElement}
				quantity={addon.quantity}
			></AddonUI>
		</React.Fragment>
	);
});

const AddonSummary = observer(({ addon, parentItem, price_zero,isCustomize,screen,cartStore }) => {
	let nameAd=addon.name;
	let nameAd1=addon.name;
	if(isCustomize)
	{
		if(screen==='cart')
		{
			nameAd=addon.name +' ('+addon.priceName+')';
		}
		else if(screen==='iteminfo')
		{
			nameAd=addon.priceName;
		}
	}
	if(addon.image && (addon.image).match(regexDefaultImage)) {
		addon.image = false;
	}
	
	// NEW: Membership pricing logic for cart addon display
	let standardPrice = parseFloat(addon.price) || 0;
	let membershipPrice = standardPrice;
	let hasMembershipPricing = false;

	// Check if user is logged in and has membership
	const isLoggedIn = cartStore && cartStore.menuStore && 
		cartStore.menuStore.isLoginModalVisible === false && 
		cartStore.menuStore.social && 
		Object.keys(cartStore.menuStore.social).length > 0;

	const tokenExpiry = localStorage.getItem(
		`${cartStore && cartStore.menuStore && cartStore.menuStore.controller ? cartStore.menuStore.controller : ''}_advocado_token_expiry`
	);
	const now = new Date().getTime();
	const useMembership = tokenExpiry && parseInt(tokenExpiry) > now;

	const shouldShowMembershipPricing = isLoggedIn && useMembership && 
		cartStore && cartStore.menuStore && cartStore.menuStore.social && cartStore.menuStore.social.provider === 'advocado';

	// Try to find membership pricing for this addon using parentItem data
	if (parentItem && screen === 'cart') {
		// Method 1: Check if parentItem has explicit membershipPrice and priceOptions
		if (parentItem.membershipPrice && parentItem.priceOptions) {
			const membershipOption = parentItem.priceOptions.find(opt => 
				opt && opt.name && String(opt.name).toLowerCase() === 'membership'
			);

			if (membershipOption && membershipOption.set) {
				// Look for this specific addon in membership pricing structure
				const memberAddon = membershipOption.set.find(ma => ma.id === addon.id);
				if (memberAddon) {
					membershipPrice = parseFloat(memberAddon.price) || standardPrice;
					hasMembershipPricing = standardPrice > membershipPrice;
				}
			}
		}

		// Method 2: Fallback - look for duplicate addon pattern (like in ItemInfo)
		// This handles cases where backend sends separate standard/membership addons
		if (!hasMembershipPricing && addon.name) {
			// For cart display, we assume the pricing has been resolved at order time
			// So we show the current price but indicate if membership pricing exists
			if (parentItem.membershipPrice) {
				hasMembershipPricing = true;
				// Calculate estimated membership price (10% discount as fallback)
				membershipPrice = standardPrice * 0.9;
			}
		}
	}

	// Debug log for cart addon pricing
	if (screen === 'cart') {
		console.log('[AddonSummary Debug] Membership conditions:', {
			addonName: addon.name,
			isLoggedIn: isLoggedIn,
			useMembership: useMembership,
			socialProvider: cartStore && cartStore.menuStore && cartStore.menuStore.social && cartStore.menuStore.social.provider,
			shouldShowMembershipPricing: shouldShowMembershipPricing,
			hasMembershipPricing: hasMembershipPricing,
			standardPrice: standardPrice,
			membershipPrice: membershipPrice
		});
	}
	
	return addon.quantity ? (
		<React.Fragment>
			<AddonUI
				uiType="stepper"
				enableImage={cartStore && cartStore.menuStore && addon.image ? cartStore.menuStore.isSubItemImageEnable() : false}
				title={nameAd1} 
				thumb={addon.image}
				price={
					hasMembershipPricing && shouldShowMembershipPricing ? (
						<div className="addon-price-container" style={{marginTop: '4px', lineHeight: '1.4'}}>
							<div className="itemPrice standard-price">Standard: {cartStore.menuStore.currencySymbol} {standardPrice.toFixed(2)}</div>
							<div className="itemPrice membership-price" style={{color: 'rgb(255, 107, 0)', marginTop: '2px'}}>Member: {cartStore.menuStore.currencySymbol} {membershipPrice.toFixed(2)}</div>
						</div>
					) : hasMembershipPricing ? (
						// Show both prices even if not logged in for transparency
						<div className="addon-price-container" style={{marginTop: '4px', lineHeight: '1.4'}}>
							<div className="itemPrice standard-price">Standard: {cartStore.menuStore.currencySymbol} {standardPrice.toFixed(2)}</div>
							<div className="itemPrice membership-price" style={{color: 'rgb(255, 107, 0)', marginTop: '2px'}}>Member: {cartStore.menuStore.currencySymbol} {membershipPrice.toFixed(2)}</div>
						</div>
					) : (
						parseFloat(addon.price) === 0 ? price_zero : addon.priceName
					)
				}
				quantity={addon.quantity}
			></AddonUI>
		</React.Fragment>
	) : null;
});

const RenderAddon = observer(({addonSlected}) => {
	// Kiểm tra addonSlected có tồn tại và có phần tử không
	// MobX ObservableArray không được nhận diện bởi Array.isArray(), nên cần kiểm tra khác
	if (!addonSlected || (addonSlected.length === undefined && !Array.isArray(addonSlected)) || addonSlected.length === 0) {
		return null;
	}
	
	let firstAddonSlected=addonSlected[0];
	
	// Kiểm tra firstAddonSlected có tồn tại và không null/undefined không
	if (!firstAddonSlected || typeof firstAddonSlected !== 'object') {
		return null;
	}
	
	// Kiểm tra xem firstAddonSlected có phải là object với keys không
	let keys = Object.keys(firstAddonSlected);
	
	if (keys.length === 0) {
		return null;
	}
	
	let allAddonsElem=[];
	_.each(keys, (key, index) => {			  
		_.each(firstAddonSlected[key], (addon, addonIndex) => { 
			if(addon.quantity===1 && addon.groupName)
			{
				//let name=addon.name+(addon.modifiers && addon.modifiers!==""? ' ['+addon.modifiers+']':'');	
				allAddonsElem.push(<div key={`${index}-${addonIndex}-name`} className="briefoptions addontitle">{addon.name}</div>);
				if(addon.modifiers && addon.modifiers!=="")
				{
					allAddonsElem.push(<div key={`${index}-${addonIndex}-modifier`} className="briefoptions modifierright">{' ['+addon.modifiers+']'}</div>);
				}
			}
		});	   
	});
	
  	return allAddonsElem;
});

const RenderNotes = observer(({entry}) => {
let spRequets=[];
// Kiểm tra entry và entry.notes có tồn tại không

if (entry && entry.notes && entry.notes.length > 0) {
	_.each(entry.notes, (note, index) => {
		if (note !== '' && spRequets.length===0) { 
			spRequets.push(note); 
		}
	});
}
spRequets = spRequets.join(', ');

	if(spRequets!=="")
	{
	return (<div className="briefoptions">             
		[{spRequets}]
		</div>);	
	}
	return('');
});

export { AddonFixed, AddonSingle, AddonMultiple, AddonSummary,ModifierSingle,RenderAddon,RenderNotes };
